<script>
import MENU from '../../../router/menu';
import { mapGetters } from 'vuex';


export default {
  data() {
    return {
      menus: MENU,
      activeMenuParent: [],
      activeMenuPath: '',
      resource: {},
        rolesId: null
    };
  },
  computed: {
    global() {
      return this.$store.getters.getGlobal;
    },
    ...mapGetters({
      actionTab: 'getActionTab',
      userInfo: 'getUserInfo',
      global: 'getGlobal',
      asideMenuList: 'getAsideMenuList'
    }),
  },
  watch: {
      asideMenuList(val){
          this.resource = val
      },
    resource() {
      this.autoSelectMenu();
    },
    $route() {
      this.autoSelectMenu();
    },
    actionTab(val) {
      this.activeMenuPath = val;
    }
  },
    render(createElement, hack) {
      const create =  (menuNode, createElement) => {
            if(Array.isArray(menuNode)){
                return createElement("aside",
                   [
                       createElement(
                           "Menu",
                           {
                               class: {
                                   'aside-menu': true
                               },
                               props: {
                                   'theme': 'light',
                                   'activeName': this.activeMenuPath,
                                   'open-names': this.activeMenuParent,
                                   'accordion': true
                               },
                               on: {
                                   'on-select': this.selectMenu
                               },
                               style: {
                                   width: '100%'
                               },
                               ref : 'menu'
                           },
                           [
                               ...menuNode.map(item => {
                                   return create(item, createElement)
                               })
                           ]
                       )
                   ]
                )
            }


          if(menuNode.subMenus && menuNode.subMenus.length  && this.resource[menuNode.meta.uri] && !menuNode.hide){
              return createElement(
                  "Submenu",
                  {
                      props: {
                          name: menuNode.id,
                          key:  menuNode.path
                      }
                  },
                  [
                      createElement('template', {
                              slot : 'title' //指定 title 插槽内容
                          },
                          [
                              // 创建图标
                              createElement('Icon', {
                                  props : {
                                      // type :menuNode.meta.icon
                                  },
                                  class: {
                                     [menuNode.meta.icon]: true
                                  },
                                  style: {
                                      fontSize: '14px'
                                  }
                              }),
                              // 设置菜单名称
                              menuNode.meta.title
                          ]
                      ),
                      ...menuNode.subMenus.map(function(item) {
                          return create(item, createElement)
                      })
                  ]
              )
          }


          // 创建 MenuItem 节点
          if( this.resource[menuNode.meta.uri] &&  !menuNode.hide){
              return createElement(
                  'MenuItem',
                  {
                      props : {
                          name : menuNode.path ,
                          key: menuNode.meta.uri
                      }
                  },
                  [
                      // 创建图标
                      createElement('Icon', {
                          props : {
                              // type :menuNode.meta.icon
                          },
                          class: {
                              [menuNode.meta.icon]: true
                          },
                          style: {
                              fontSize: '14px'
                          }
                      }),
                      createElement('template', {
                              slot : 'default'
                          },
                          // 设置菜单名称
                          menuNode.meta.title
                      ),
                  ]
              );
          }

        }

        return create(this.menus,  createElement)
    },
    methods: {
    menuIcon(val) {
      if (val.indexOf(' ') >= 0) return { custom: val };
      return { type: val };
    },
    autoSelectMenu() {
      this.activeMenuPath = this.$route.path;
      this.$nextTick(() => {
        this.$refs.menu.updateActiveName();
        this.$refs.menu.updateOpened();
      });
    },

    selectMenu(link) {
        if (!link)return;
        this.$router.push({
            path: link,
            query: {
                t: Date.now(),
            },
        });
    },
  },
  created() {

  },
};
</script>
<style lang="less">
    @import '../../../assets/less/variable';
    /* 设置导航背景色 */
    @aside_sub_menu_bgcolor:#EBEBEB; // 二级导航背景色
    @aside_active_menu_color:#CA4E49; // 选中导航背景色及active时文字颜色
    @aside_selected_textcolor: white; // 选中导航文字色
    .ivu-menu{
        color: @text-color65;
    }
    aside {
        position: relative;
        background-color: @main-gray-bgcolor;
        box-shadow: 1px 0px 2px 1px rgba(212,215,217,1);
        .ivu-menu-light.ivu-menu-vertical{
            .ivu-menu-item-active:not(.ivu-menu-submenu){
                color: @aside_selected_textcolor;
                background: @aside_active_menu_color;
            }
            .ivu-menu-item-active:not(.ivu-menu-submenu):after{
                background-color: transparent;
            }
            .ivu-menu-item-active .ivu-menu-submenu-title{
                border-left: 2px solid  @aside_active_menu_color;
            }
            .ivu-menu-item:not(.ivu-menu-item-selected):hover,.ivu-menu-submenu-title:hover{
                color: @aside_active_menu_color;
                font-weight: bold;
            }
            &:after{
                background-color: transparent;
            }
        }
        .aside-menu:hover {
          overflow-y: auto;
          overflow-x: hidden;
        }
        .ivu-menu-submenu-title-icon {
          right: auto !important;
          left:calc(@view-left - 30px) !important;
        }
        .aside-menu {
            overflow: hidden;
            // overflow-y: auto;
            // overflow-x: hidden;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            font-size: 12px;
            bottom: 0px;
            background-color: @main-gray-bgcolor;
            .ivu-menu-item {
                font-size: 12px;
                padding-top: 12px;
                padding-bottom: 12px;
                background-color: @aside_sub_menu_bgcolor;
            }
            .index-icon {
                margin-right: 8px;
            }
            .submenu-container {
                .ivu-menu-submenu-title {
                    padding-top: 12px;
                    padding-bottom: 12px;
                }
                .ivu-menu-item {
                    padding-top: 8px;
                    padding-bottom: 8px;
                }
            }

        }
        .copyright {
          display: none;
          color: @text-color45;
          position: absolute;
          height: @view-copyright;
          line-height: @view-copyright;
          bottom: 0;
          left: 0;
          right: 0;
          text-align: center;
          z-index: 1;
        }
    }

</style>









<!--<template>-->
<!--    <aside>-->
<!--        <Menu ref='menu' theme='light' :active-name="activeMenuPath" accordion-->
<!--              class='aside-menu' @on-select='selectMenu' width="100%"-->
<!--              :open-names='activeMenuParent'>-->

<!--            <template>-->
<!--                <Menu-item name="1" v-for='(menuParent) in menus' v-if="!menuParent.hide">-->
<!--                    <template slot="title">-->
<!--                        <Icon type="ios-analytics" />-->
<!--                        Navigation One-->
<!--                    </template>-->
<!--                </Menu-item>-->
<!--            </template>-->

<!--        </Menu>-->
<!--        &lt;!&ndash; <div class="copyright">{{$i18n.locale === 'zh-CN' ? global.home.copyright : global.home.copyright_en}}</div> &ndash;&gt;-->
<!--    </aside>-->
<!--</template>-->

<!--<template v-for='(menu) in menuParent.subMenus' v-if="!menu.hide">
    <Submenu :name="menuParent.meta.title || ''"  :key="menuParent.meta.uri">
        <template >
            <Menu-item :name="menu.path" :key="menu.meta.uri" v-if="!menu.subMenus && resource[menu.meta.uri]">
                <Icon v-bind="$filter.iconTypeCostum(menu.meta.icon)" :size="16"></Icon>
                <span class="layout-text">{{$t(`menu['${menu.meta.uri}']`)}}</span>
            </Menu-item>
            <Submenu :name='menu.meta.title' v-if="menu.subMenus && resource[menu.meta.uri]"
                     :key='menu.meta.uri'>
                <template slot='title'>
                    <Icon v-bind="$filter.iconTypeCostum(menu.meta.icon)" :size="16"></Icon>
                    <span class="layout-text">{{$t(`menu['${menu.meta.uri}']`)}}</span>
                </template>

                <template v-for="(submenu) in menu.subMenus">
                    <Menu-item :name="submenu.path || ''"  :key="submenu.meta.uri"
                               v-if="resource[submenu.meta.uri] && !submenu.hide && !submenu.isThree">
                        <Icon v-bind="$filter.iconTypeCostum(submenu.meta.icon)" :size="16"></Icon>
                        <span class="layout-text">{{$t(`menu['${submenu.meta.uri}']`)}}</span>
                    </Menu-item>
                    <Submenu :name="submenu.meta.title || ''" v-if="submenu.isThree"   :key="submenu.meta.uri">
                        <template slot="title">
                            <Icon v-bind="$filter.iconTypeCostum(submenu.meta.icon)" :size="16"></Icon>
                            <span class="layout-text">{{$t(`menu['${submenu.meta.uri}']`)}}</span>
                        </template>
                        <Menu-item v-for="(threeSubmenu) in submenu.subMenus"
                                   v-if="resource[threeSubmenu.meta.uri] && !threeSubmenu.hide"
                                   :key="threeSubmenu.meta.uri"
                                   :name="threeSubmenu.path">
                            <span class="layout-text">{{$t(`menu['${threeSubmenu.meta.uri}']`)}}</span>
                        </Menu-item>
                    </Submenu>
                </template>

            </Submenu>
        </template>
    </Submenu>
</template>-->
